import React, {useState,useEffect} from 'react';
import {SubmitForm} from '@gull'
import { useTranslate } from 'react-redux-multilingual'
import { useForm } from "react-hook-form";
import axios from 'axios'
import swal from "sweetalert2";

const CreateListeArticle = (props) => {
    const t = useTranslate();
    const { register, formState: { errors }, handleSubmit, reset, setValue } = useForm();
    const [validButton,setValidButton] = useState(false)
    const [apiError,setApiError] = useState(false)
    const [success,setSuccess] = useState(false)

    useEffect(function () {
        if(props.show!='createItemsList'){
            setValue('name',props.show.name)
        }
    }, [props.show])

    const onSubmit = async (data) => {
        setValidButton(true)
        setSuccess(false)
        setApiError(false)

        let obj = {
            name: data.name,
            section:(props.module=='erp') ? data.section : props.shopId
        }

        let axioAction = props.show=='createItemsList' ? axios.post : axios.put
        let url = props.show=='createItemsList' ? "api/wms/article_list" : "api/wms/article_list/"+props.show.id

        const response  = await axioAction(process.env.REACT_APP_API_URL+url,obj
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach((interm)=>{
                    let finalMessage=interm.split('/!');
                    if(finalMessage.length==2){
                        messageError+=t(finalMessage[0],{name:finalMessage[1]})+'<br/>'
                    }
                    else{
                        messageError+=t(interm)+'<br/>'
                    }
                })
                    messageError=messageError.replace('undefined','');
                    setApiError(messageError)
            }
            else{
                setSuccess(true)
                if(props.show=='createItemsList'){
                    if(props.module=='wms'){
                        //Dans le cas d'une création on ajoute un nouvelle ligne
                        props.setListeArticle([response.data.data,...props.listeArticle])
                    }else{
                        props.setReloadData(Date.now())
                    }
                }else{
                    //Dans le cas d'une édition, on met à jour le nom de la liste d'articles
                    // ici on récupère liste d'article qui doit être mis à jour
                    let liste = props.listeArticle.find(value=>value.id==props.show.id)
                    //on met à jour le nom
                    liste.name = response.data.data.name

                    //on met à jour les blocs affiché 
                    let articleList = props.listeArticle.map(value=>value.id)
                    let indexToEdit = articleList.indexOf(props.show.id)
                    let newData = props.listeArticle.filter(value=>value.id!=props.show.id)

                    newData.splice(indexToEdit,0, liste)

                    props.setListeArticle(newData)
                }
                
                props.setShow(false)
                reset()
            }
            
        }).catch((error) => {
            if(error=='end_session') return;
            let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(errorName), "", "error");
        })
        setValidButton(false)
        setTimeout(()=>{
            setSuccess(false);
        },1000)    
    }

    return(
        <div>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group" >
                    <label>{t('listName')+' :'}</label>
                    <input disabled={validButton} className="form-control" type="text" {...register('name', {required: true})}/>
                    {errors.first?.type === 'required' && (
                    <div className="text-danger mt-1 ml-2">
                        {t('fieldRequired')}
                    </div>)}
                </div>
                {props.module=='erp' ?
                    <div className="form-group" >
                        <label>{t('shop')+' :'}</label>
                        <select disabled={validButton} className="form-control" {...register('section', {required: true})}>
                            <option value="">-- Select</option>
                            {props.sections.map(shop => {
                                return(
                                    <option key={shop.id} value={shop.id}>{shop.name}</option>
                                )
                            })}
                        </select>
                        {errors.first?.type === 'required' && (
                        <div className="text-danger mt-1 ml-2">
                            {t('fieldRequired')}
                        </div>)}
                    </div>
                :
                    false
                }
                <SubmitForm validButton={validButton} success={success} error={apiError} />
            </form>
        </div>
    )
}

export default CreateListeArticle;